<template>
    <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M87.75 29.25L42.25 74.75L19.5 52" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>